export default "/fonts/vendor/material-icons/iconmaterial-icons-two-tone.woff?3baa5b8f3469222b822d0c748fc81ec7";